/**
 * Example images configuration for each upload slot by category.
 * Shows users what kind of photo to take for each slot.
 * 
 * Images from Unsplash (free, no attribution required for use).
 * In production, these should be replaced with TFD's own example photos.
 */

const EXAMPLE_IMAGES = {
  handbags: {
    front: {
      url: "https://images.unsplash.com/photo-1584917865442-de89df76afd3?w=200&h=200&fit=crop",
      tip: "Full front view, centered, on a flat surface"
    },
    back: {
      url: "https://images.unsplash.com/photo-1590874103328-eac38a683ce7?w=200&h=200&fit=crop",
      tip: "Full back view showing any pockets or details"
    },
    interior: {
      url: "https://images.unsplash.com/photo-1654987245146-342026c56180?w=200&h=200&fit=crop",
      tip: "Open bag showing interior lining, pockets, stamps"
    },
    logo: {
      url: "https://images.unsplash.com/photo-1632251657417-585ab7d16043?w=200&h=200&fit=crop",
      tip: "Close-up of the brand logo or monogram"
    },
    made_in_tag: {
      url: "https://images.unsplash.com/photo-1673105625100-537c3b44fafc?w=200&h=200&fit=crop",
      tip: "Close-up of the 'Made in' tag or label"
    },
    branded_hardware: {
      url: "https://images.unsplash.com/photo-1630701875820-1250d036825d?w=200&h=200&fit=crop",
      tip: "Close-up of zippers, clasps, or buckles with brand marks"
    },
    serial_number: {
      url: "https://images.unsplash.com/photo-1689061188901-08a7eadd423d?w=200&h=200&fit=crop",
      tip: "Close-up of serial/date code stamp"
    },
  },
  accessories: {
    front: {
      url: "https://images.unsplash.com/photo-1606522754091-d86bbd9f4b30?w=200&h=200&fit=crop",
      tip: "Full front view of the accessory"
    },
    back: {
      url: "https://images.unsplash.com/photo-1590874103328-eac38a683ce7?w=200&h=200&fit=crop",
      tip: "Full back view"
    },
    interior: {
      url: "https://images.unsplash.com/photo-1654987245146-342026c56180?w=200&h=200&fit=crop",
      tip: "Interior view if applicable"
    },
    logo: {
      url: "https://images.unsplash.com/photo-1632251657417-585ab7d16043?w=200&h=200&fit=crop",
      tip: "Close-up of brand logo"
    },
    made_in_tag: {
      url: "https://images.unsplash.com/photo-1673105625100-537c3b44fafc?w=200&h=200&fit=crop",
      tip: "Close-up of origin tag"
    },
    branded_hardware: {
      url: "https://images.unsplash.com/photo-1630701875820-1250d036825d?w=200&h=200&fit=crop",
      tip: "Close-up of branded hardware"
    },
    serial_number: {
      url: "https://images.unsplash.com/photo-1689061188901-08a7eadd423d?w=200&h=200&fit=crop",
      tip: "Serial number or date code"
    },
  },
  clothing: {
    front: {
      url: "https://images.unsplash.com/photo-1558171813-01eda89a5f99?w=200&h=200&fit=crop",
      tip: "Full front view laid flat or on hanger"
    },
    back: {
      url: "https://images.unsplash.com/photo-1523381294911-8d3cead13475?w=200&h=200&fit=crop",
      tip: "Full back view"
    },
    care_tag: {
      url: "https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?w=200&h=200&fit=crop",
      tip: "Close-up of care/wash label"
    },
    neck_made_in_tag: {
      url: "https://images.unsplash.com/photo-1556905055-8f358a7a47b2?w=200&h=200&fit=crop",
      tip: "Neck label or 'Made in' tag"
    },
    closure: {
      url: "https://images.unsplash.com/photo-1551488831-00ddcb6c6bd3?w=200&h=200&fit=crop",
      tip: "Buttons, zippers, or closure details"
    },
    ornament: {
      url: "https://images.unsplash.com/photo-1551489186-cf8726f514f8?w=200&h=200&fit=crop",
      tip: "Any ornamental details or embellishments"
    },
    serial_number: {
      url: "https://images.unsplash.com/photo-1673105625100-537c3b44fafc?w=200&h=200&fit=crop",
      tip: "Serial number tag if present"
    },
  },
  shoes: {
    front: {
      url: "https://images.unsplash.com/photo-1543163521-1bf539c55dd2?w=200&h=200&fit=crop",
      tip: "Front view of the pair together"
    },
    back: {
      url: "https://images.unsplash.com/photo-1595950653106-6c9ebd614d3a?w=200&h=200&fit=crop",
      tip: "Back/heel view of the pair"
    },
    bottom: {
      url: "https://images.unsplash.com/photo-1606107557195-0e29a4b5b4aa?w=200&h=200&fit=crop",
      tip: "Bottom/sole of one shoe"
    },
    interior_logo: {
      url: "https://images.unsplash.com/photo-1551107696-a4b0c5a0d9a2?w=200&h=200&fit=crop",
      tip: "Interior logo or insole stamp"
    },
    shoe_profile: {
      url: "https://images.unsplash.com/photo-1600185365483-26d7a4cc7519?w=200&h=200&fit=crop",
      tip: "Side profile view"
    },
    size_serial: {
      url: "https://images.unsplash.com/photo-1560769629-975ec94e6a86?w=200&h=200&fit=crop",
      tip: "Size label and serial number"
    },
  },
  jewelry: {
    front: {
      url: "https://images.unsplash.com/photo-1515562141589-67f0d569b6fc?w=200&h=200&fit=crop",
      tip: "Full front view on neutral background"
    },
    back: {
      url: "https://images.unsplash.com/photo-1573408301185-9146fe634ad0?w=200&h=200&fit=crop",
      tip: "Back view showing clasp or closure"
    },
    brand_markings: {
      url: "https://images.unsplash.com/photo-1605100804763-247f67b3557e?w=200&h=200&fit=crop",
      tip: "Close-up of brand stamps or engravings"
    },
    logo: {
      url: "https://images.unsplash.com/photo-1617038220319-276d3cfab638?w=200&h=200&fit=crop",
      tip: "Brand logo detail"
    },
    hallmark: {
      url: "https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=200&h=200&fit=crop",
      tip: "Hallmark or purity stamp"
    },
    made_in_stamp: {
      url: "https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?w=200&h=200&fit=crop",
      tip: "Origin stamp or maker's mark"
    },
  },
  watches: {
    front: {
      url: "https://images.unsplash.com/photo-1524592094714-0f0654e20314?w=200&h=200&fit=crop",
      tip: "Full dial face view, straight on"
    },
    back: {
      url: "https://images.unsplash.com/photo-1587836374828-4dbafa94cf0e?w=200&h=200&fit=crop",
      tip: "Case back showing engravings"
    },
    brand_markings: {
      url: "https://images.unsplash.com/photo-1526045431048-f857369baa09?w=200&h=200&fit=crop",
      tip: "Close-up of brand name on dial"
    },
    logo: {
      url: "https://images.unsplash.com/photo-1547996160-81dfa63595aa?w=200&h=200&fit=crop",
      tip: "Crown or logo on the crown/case"
    },
    hallmark: {
      url: "https://images.unsplash.com/photo-1548171915-e79a380a2a4b?w=200&h=200&fit=crop",
      tip: "Serial and model number engravings"
    },
    made_in_stamp: {
      url: "https://images.unsplash.com/photo-1509048191080-d2984bad6ae5?w=200&h=200&fit=crop",
      tip: "Swiss Made marking or origin stamp"
    },
  },
};

export default EXAMPLE_IMAGES;
